import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { PhoneIssuesChipAndMenuComponent } from './phone-issues-chip-and-menu.component';

@NgModule({
   declarations: [PhoneIssuesChipAndMenuComponent],
   imports: [CommonModule, MatMenuModule, MatChipsModule, MatIconModule],
   exports: [PhoneIssuesChipAndMenuComponent],
})
export class PhoneIssuesChipAndMenuModule {}
